module.exports = __webpack_public_path__ + "static/media/happy_ladies_2.6f2b22db.png";